// Progressive enhancement of native details; keyboard/click still work without hover.
(() => {
  let headerObserver;
  const observeHeader = () => {
    headerObserver?.disconnect();
    const header = document.querySelector('.site-header');
    if (!header) return;
    const updateHeight = () => document.documentElement.style.setProperty('--sticky-header-height', `${header.getBoundingClientRect().height}px`);
    updateHeight();
    headerObserver = new ResizeObserver(updateHeight);
    headerObserver.observe(header);
  };
  observeHeader();
  document.addEventListener('shopify:section:load', observeHeader);
  document.addEventListener('shopify:section:unload', observeHeader);
  const desktopHover = matchMedia('(min-width: 750px) and (hover: hover)');
  const closeTimers = new WeakMap();
  const cancelClose = menu => clearTimeout(closeTimers.get(menu));
  const closePeers = menu => {
    menu.closest('.desktop-nav')?.querySelectorAll('.nav-dropdown[open]').forEach(peer => {
      if (peer !== menu) { cancelClose(peer); peer.open = false; }
    });
  };
  document.addEventListener('pointerover', event => {
    if (!desktopHover.matches || event.pointerType === 'touch') return;
    const menu = event.target.closest('.desktop-nav .nav-dropdown');
    if (!menu) return;
    cancelClose(menu);
    if (!menu.contains(event.relatedTarget)) { closePeers(menu); menu.open = true; }
  });
  document.addEventListener('pointerout', event => {
    const menu = event.target.closest('.desktop-nav .nav-dropdown');
    if (!menu || menu.contains(event.relatedTarget) || !desktopHover.matches) return;
    cancelClose(menu);
    closeTimers.set(menu, setTimeout(() => {
      if (!menu.contains(document.activeElement)) menu.open = false;
    }, 180));
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches('.desktop-nav .nav-dropdown') && event.target.open) closePeers(event.target);
  }, true);
  document.addEventListener('focusout', event => {
    const menu = event.target.closest('.desktop-nav .nav-dropdown');
    if (menu && !menu.contains(event.relatedTarget)) { cancelClose(menu); menu.open = false; }
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('.mega-panel a');
    if (link) link.closest('details').open = false;
  });
  matchMedia('(min-width: 750px)').addEventListener('change', () => {
    document.querySelectorAll('.desktop-nav .nav-dropdown[open]').forEach(menu => { cancelClose(menu); menu.open = false; });
  });
})();
